import apiClient from '../../../common/functions/api_axios_instance.function';
import {
  GET_ALL_RAN_DB_AUDIT_LOGS,
  RAN_DB_AUDIT_LOG_SITE,
} from '../../../common/constants/constants';

export const getAuditLogs = async (siteCode) => {
  try {
    if (siteCode) {
      const response = await apiClient.get(RAN_DB_AUDIT_LOG_SITE(siteCode));
      return response.data.response || [];
    }
  } catch (e) {
    return [];
  }
};

export const getAllAuditLogs = async () => {
  try {
    const response = await apiClient.get(GET_ALL_RAN_DB_AUDIT_LOGS);
    return response.data.response || [];
  } catch (e) {
    return [];
  }
};
